<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                </CCol>
                <CCol>
                    <ButtonCreate
                        :title="$t('create_new_landing')"
                        @click="
                            $router.push({
                                name: 'view_creativity',
                                query: { view_type: 'new' },
                            })
                        "
                    >
                        {{ $t("create_landing") }}
                    </ButtonCreate>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.templates.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow
                    v-show="
                        hasItemsInTable({
                            tableName: 'templates',
                        })
                    "
                >
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <!-- Button back -->
                                <div class="d-flex">
                                    <TableSettings
                                        :allFields="tables.templates.allFields"
                                        :activeFields.sync="
                                            tables.templates.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.templates.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.templates.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :columnFilterValue.sync="
                                        tables.templates.columnFilterValue
                                    "
                                    :sorterValue.sync="
                                        tables.templates.sorterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.templates.rows"
                                    v-bind="tables.templates"
                                >
                                    <template #over-table>
                                        <CContainer :fluid="true">
                                            <CRow alignHorizontal="start">
                                                <CDropdown
                                                    color="primary"
                                                    :toggler-text="
                                                        $t('actions')
                                                    "
                                                    class="m-2"
                                                    :disabled="
                                                        tables.templates
                                                            .itemSelected ===
                                                        null
                                                    "
                                                >
                                                    <CDropdownItem
                                                        @click="
                                                            $router.push({
                                                                name: 'update_creativity',
                                                                params: {
                                                                    uuid: tables
                                                                        .templates
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{
                                                            $t("edit_template")
                                                        }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        @click="
                                                            openEditor(
                                                                tables.templates
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        {{ $t("open_editor") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        v-if="
                                                            tables.templates
                                                                .itemSelected
                                                        "
                                                        :disabled="
                                                            stringToBoolean(
                                                                tables.templates
                                                                    .itemSelected
                                                                    .is_template_step
                                                            ) == false
                                                        "
                                                        @click="
                                                            $router.push({
                                                                name: 'template_steps',
                                                                params: {
                                                                    uuid: tables
                                                                        .templates
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{ $t("steps") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        v-if="
                                                            tables.templates
                                                                .itemSelected
                                                        "
                                                        @click="
                                                            buildPreview({
                                                                uuid: tables
                                                                    .templates
                                                                    .itemSelected
                                                                    .uuid,
                                                            })
                                                        "
                                                    >
                                                        {{ $t("preview") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        v-if="
                                                            tables.templates
                                                                .itemSelected
                                                        "
                                                        @click="
                                                            buildDemo({
                                                                uuid: tables
                                                                    .templates
                                                                    .itemSelected
                                                                    .uuid,
                                                            })
                                                        "
                                                    >
                                                        {{ $t("Demo") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        v-if="
                                                            tables.templates
                                                                .itemSelected
                                                        "
                                                        @click="
                                                            cloneTemplate(
                                                                tables.templates
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        {{ $t("clone") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        v-if="
                                                            tables.templates
                                                                .itemSelected
                                                        "
                                                        @click="
                                                            deleteItem(
                                                                tables.templates
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        {{ $t("delete") }}
                                                    </CDropdownItem>
                                                </CDropdown>
                                            </CRow>
                                        </CContainer>
                                    </template>
                                    <template #_selected="{ item }">
                                        <td class="py-2">
                                            <CInputRadio
                                                name="_selected"
                                                :checked="
                                                    item ===
                                                    tables.templates
                                                        .itemSelected
                                                "
                                                @update:checked="
                                                    selectItemTable(
                                                        'templates',
                                                        item
                                                    )
                                                "
                                            />
                                        </td>
                                    </template>
                                    <template #no-items-view>
                                        <slot name="no-items-view">
                                            <div class="block-no-items section">
                                                <!-- <span class="emoji">&#128557;</span> -->
                                                <br />
                                                <h2
                                                    class="section__title text-no-items"
                                                >
                                                    {{
                                                        $t(
                                                            "no-items-text.creativities"
                                                        )
                                                    }}
                                                </h2>
                                            </div>
                                        </slot>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.templates.total_pages > 0"
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.templates.page"
                                        :pages="tables.templates.total_pages"
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.templates.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
            <NoItemsContainer
                v-show="
                    !hasItemsInTable({
                        tableName: 'templates',
                    })
                "
            >
                <template #title>
                    {{ $t("Create your first landing") }}
                </template>
                <template #description>
                    {{ $t("Create a template for your landing pages") }}
                </template>
                <template #redirect>
                    <ButtonCreate
                        :title="$t('Create my first landing!')"
                        @click="
                            $router.push({
                                name: 'view_creativity',
                                query: { view_type: 'new' },
                            })
                        "
                    >
                        {{ $t("Create my first landing!") }}
                    </ButtonCreate>
                </template>
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'templates',
                            })
                        "
                        @click="cleanFiltersAdvance('templates'), updateData()"
                    >
                        <span class="button__icon">
                            <CIcon :content="$options.icons.eraser" />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean filters") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/**
 * Components
 */
import FilterDate from "~/components/FilterDate";
import ButtonCreate from "~/components/ButtonCreate";
import ButtonExport from "~/components/ButtonExport";
import FilterFields from "~/components/FilterFields";
import NoItemsContainer from "~/components/NoItemsContainer";
import TableSettings from "£lement/TableSettings";

/**
 * Mixins
 */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/**
 * Others
 */
import {
    cilPlus,
    cilSettings,
    cilPencil,
    cilTrash,
    cilCopy,
    cilMediaPlay,
} from "@coreui/icons";
import { mapGetters } from "vuex";
import axios from "axios";
import { eraser } from "~/assets/icons/js/eraser";

import Swal from "sweetalert2";

export default {
    name: "CreativityPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        ButtonCreate,
        ButtonExport,
        FilterFields,
        NoItemsContainer,
        TableSettings,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilMediaPlay,
        cilCopy,
        eraser,
    },
    data() {
        return {
            tables: {
                templates: {
                    fields: [
                        {
                            key: "_selected",
                            label: "",
                            sorter: true,
                            filter: false,
                            fixed: true,
                            _filter: false,
                        },
                        {
                            key: "id",
                            label: "#",
                            sorter: true,
                            filter: false,
                            _filter: true,
                        },
                        {
                            key: "name",
                            label: "name",
                            sorter: true,
                            filter: true,
                            _filter: true,
                        },
                        {
                            key: "created_at",
                            label: "created_at",
                            sorter: true,
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "updated_at",
                            label: "updated_at",
                            sorter: true,
                            filter: false,
                            _filter: false,
                        },
                    ],
                    items: [],
                    allFields: [],
                    order: "desc",
                    page: 1,
                    rows: 10,
                    total_pages: 1,
                    loading: true,
                    pagination: true,
                    sorter: {
                        external: true,
                        resetable: true
                    },
                    sorterValue: {},
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    columnFilterValue: {},
                    itemsPerPageSelect: true,
                    itemSelected: null,
                },
            },
        };
    },
    computed: {
        ...mapGetters({
            from: "filter/from",
            to: "filter/to",
        }),
    },
    methods: {
        itemPerPage(newValue) {
            this.tables.templates.rows = newValue;
            this.updatePagination(this.tables.templates.page);
        },
        updatePagination(newValue) {
            this.tables.templates.page = newValue;
            this.updateData();
        },
        async updateData() {
            await this.updateTable({
                tableName: "templates",
                url: "/templates.api",
            });
            this.tables.templates.itemSelected = null;
            this.updatePageLoading(false);
        },
        async cloneTemplate(item) {
            await this.fetcher({
                url: `/templates.api/${item.uuid}/clone`,
                method: "POST",
            });
            this.updateData();
        },
        async deleteItem(item) {
            try {
                await this.deleteData({
                    url: `/templates.api/${item.uuid}/delete`,
                });
                this.updateData();
            } catch (error) {
                return;
            }
        },
        async buildPreview({ uuid }) {
            try {
                const { data } = await axios.get(
                    "/template.api/" + uuid + "/deploy/"
                );
                if (data.success) {
                    let a = document.createElement("a");
                    let findIndex = data.landing_page.findIndex((url) => {
                        return url.includes("index");
                    });
                    a.setAttribute("href", data.landing_page[findIndex]);
                    a.setAttribute("target", "_blank");
                    a.click();
                }
            } catch (error) {
                this.showMessageError(error);
            }
        },
        async buildDemo({ uuid }) {
            try {
                const { data } = await axios.get(
                    "/template.api/" + uuid + "/demo/deploy"
                );
                if (data.success) {
                    let a = document.createElement("a");
                    let findIndex = data.landing_page.findIndex((url) => {
                        return url.includes("index");
                    });
                    a.setAttribute("href", data.landing_page[findIndex]);
                    a.setAttribute("target", "_blank");
                    a.click();
                }
            } catch (error) {
                this.showMessageError(error);
            }
        },

        async openEditor(item) {
            if (!this.stringToBoolean(item.is_template_step)) {
                this.$router.push({
                    name: "landing_builder",
                    params: {
                        uuid: this.tables.templates.itemSelected.uuid,
                    },
                });
            } else {
                let result = await Swal.fire({
                    title: this.$t("Template or step?"),
                    text: this.$t(
                        "This template has steps, if you select template, open the template editor. If you select step, you will open the editor of the first step."
                    ),
                    icon: "question",
                    showDenyButton: true,
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    denyButtonColor: "#3085d6",
                    confirmButtonText: this.$t("Template"),
                    denyButtonText: this.$t("Step"),
                });
                if (result.isConfirmed) {
                    this.$router.push({
                        name: "landing_builder",
                        params: {
                            uuid: item.uuid,
                        },
                    });
                } else if (result.isDenied) {
                    try {
                        this.updatePageLoading(true);
                        let resp = await this.fetcher({
                            url: `/templates.api/${item.uuid}/steps`,
                        });
                        this.$router.push({
                            name: "step_builder",
                            params: {
                                stepId: resp._items[0].uuid,
                                templateId: item.uuid,
                            },
                        });
                    } catch (error) {
                    } finally {
                        this.updatePageLoading(false);
                    }
                }
            }
        },
    },
    mounted() {
        this.updateData();
    },
};
</script>

<style></style>
